import {SlotInfoCardComponent} from './Components/slot-info-card.component';
import ShowreelSection from './Components/Sections/Showreel.Section';
import React from 'react';

export const Slots = [
    {
        id: 'ds-new-year',
        year: 2025,
        title: 'Diamond Strike New Year',
        icon: 'https://storage.googleapis.com/lesia-k/SlotArt2025/NewYear/iconNY.png',
        descriptionTxt: <div className={"text-white"}>
            A New Year-themed Hold-and-Win slot with a bonus game.
            My task was to refresh the entire visual identity of the core slot and adapt it to the upcoming holiday
            season. This required extensive rework and careful restyling - ensuring that every element, from symbols to
            UI accents, reflected the festive New Year atmosphere.
            The result is a fully transformed slot where each component has been thoughtfully redesigned to evoke
            warmth, celebration, and a heightened sense of holiday excitement.
        </div>,
        description:
            <ShowreelSection videoUrl={"https://storage.googleapis.com/lesia-k/SlotArt2025/NewYear/ny_showreel.mp4"}/>,
        images: [
            'https://storage.googleapis.com/lesia-k/SlotArt2025/NewYear/1NY.jpg',
            'https://storage.googleapis.com/lesia-k/SlotArt2025/NewYear/2NY.jpg',
        ]
    },
    {
        id: 'diamond-strike',
        year: 2025,
        title: 'Diamond Strike',
        icon: 'https://storage.googleapis.com/lesia-k/SlotArt2025/DiamondStrike/icon.png',
        descriptionTxt: <div className={"text-white"}>
            A Hold-and-Win slot with a 3×3 reel grid and a dedicated bonus game.
            Despite its seemingly simple structure, this title posed a substantial artistic challenge. My task was to
            develop a recognizable visual style reminiscent of well-known operators while introducing entirely original
            symbols that would differentiate the slot.
            A significant emphasis was placed on animation: we incorporated advanced 2.5D techniques to create complex
            rotational and collective-movement effects for the diamond symbols, giving the game a polished, high-impact
            visual identity.
            The result is a compact yet visually sophisticated slot that showcases both stylistic precision and
            technical experimentation.
        </div>,
        description:
            <ShowreelSection
                videoUrl={"https://storage.googleapis.com/lesia-k/SlotArt2025/DiamondStrike/dimondstrike_showreel.mp4"}/>,
        images: [
            'https://storage.googleapis.com/lesia-k/SlotArt2025/DiamondStrike/1DS.jpg',
            'https://storage.googleapis.com/lesia-k/SlotArt2025/DiamondStrike/2DS.jpg',
        ]
    },
    {
        id: 'coin-up',
        year: 2025,
        icon: 'https://storage.googleapis.com/lesia-k/SlotArt2025/CoinUp/coin_up_icon.jpg',
        title: 'CoinUp',
        descriptionTxt: <div className={"text-white"}>
            A 3×3 Hold-and-Win slot with a bonus game, showcasing the full art-production pipeline.
            This slot provides a clear look into the step-by-step development of its visual identit - from initial
            sketches and rough composition to polished assets and final animation passes. Each element is carefully
            animated, and as the process unfolds, the entire slot “comes to life” on screen. It’s a compact project that
            not only delivers a classic Hold-and-Win experience, but also serves as a visual case study of how
            thoughtful art direction and animation transform a simple grid into a dynamic, engaging product.
        </div>,
        description:
            <ShowreelSection
                videoUrl={"https://storage.googleapis.com/lesia-k/SlotArt2025/CoinUp/coinup_showreel.mp4"}/>,
        // characterImage: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SeparatedElements/dog.png',
        images: [
            'https://storage.googleapis.com/lesia-k/SlotArt2025/CoinUp/CoinUp.jpg',
            'https://storage.googleapis.com/lesia-k/SlotArt2025/CoinUp/coin_up1.jpg',
            'https://storage.googleapis.com/lesia-k/SlotArt2025/CoinUp/coin_up2.jpg',
        ]
    },
    {
        id: 'sweet-galaxy',
        icon: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SpaceAdventureIcon.png',
        iconUrl: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SpaceAdventureIcon.png',
        title: 'Sweet Galaxy',
        descriptionTxt: <div className={"text-white"}>
            A cluster-style slot with semi-realistic art and dynamic reels.
            For the visual concept, I drew inspiration from classic American space comics. The main character is
            based on my colleague’s elderly dog - also a beloved member of our team.
            Forward, brave explorer of the cosmos!
        </div>,
        description: <div className={"text-center text-xl text-gray-400 font-inter"}>
            <ShowreelSection
                videoUrl={"https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SpaceAdventure720.mp4"}/>
            <h2 className={"md:text-7xl text-3xl font-boldonse p-5"}>Game Symbols</h2>
            <SlotInfoCardComponent
                rtp={96.5}
                title="Space Adventure"
                symbols={[
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SeparatedElements/dog.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SeparatedElements/blaster_symbol.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SeparatedElements/cake2_symbol.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SeparatedElements/cake3_symbol.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SeparatedElements/Cake_symbol.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SeparatedElements/Donut.png',
                ]}
            />
        </div>,
        characterImage: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SeparatedElements/dog.png',
        images: [
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SpaceAdventure1.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SpaceAdventure3.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SpaceAdventure4.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot1.Space%20Adventure/SpaceAdventure5.gif',
        ]
    },
    {
        id: 'caribbean-fishing',
        icon: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot9.CaribbeanFishing/CaribbeanFishingIcon.png',
        title: 'Caribbean',
        descriptionTxt: <div className={"text-white"}>
            A reimagined take on the classic fishing-themed slot.
            For a young studio, it was crucial to stand out and explore a range of artistic directions, gathering player
            feedback on different visual styles. With this goal in mind, I experimented extensively with alternative
            aesthetics.
            This project became a playful twist on traditional fishing slots: a pirate-themed fishing adventure rendered
            in a whimsical paper-cut visual style, filled with humorous, characterful heroes.
            A distinctive and charming experiment that helped broaden the studio’s artistic identity.
        </div>,
        description:
            <div className={"text-center text-xl text-gray-400 font-inter"}>
                <ShowreelSection
                    videoUrl={"https://storage.googleapis.com/lesia-k/SlotArt2024/Slot9.CaribbeanFishing/CaribbeanFishing480.mp4"}/>
                <h2 className={"md:text-7xl text-3xl font-boldonse p-5"}>Game Symbols</h2>
                <SlotInfoCardComponent
                    rtp={96.5}
                    title="Caribbean Fishing"
                    symbols={[
                        'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot9.CaribbeanFishing/SeparatedElements/Character.png',
                        'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot9.CaribbeanFishing/SeparatedElements/Crazy_fish.png',
                        'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot9.CaribbeanFishing/SeparatedElements/Crazy_fish2.png',
                        'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot9.CaribbeanFishing/SeparatedElements/symbol_fish.png',
                        'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot9.CaribbeanFishing/SeparatedElements/symbol_map.png',
                        'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot9.CaribbeanFishing/SeparatedElements/symbol_starfish.png',
                    ]}
                /></div>,
        characterImage: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot9.CaribbeanFishing/SeparatedElements/Character.png',
        images: [
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot9.CaribbeanFishing/CaribbeanFishing1.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot9.CaribbeanFishing/CaribbeanFishing2.gif',
        ]
    },
    {
        id: 'santa-party',
        title: 'Santa Party',
        icon: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot10.SantaTime/SantaTimeIcon.png',
        descriptionTxt: <div className={"text-white"}>
            A holiday-themed slot created as a stylistic experiment in pixel art.
            One of my key objectives was to diversify the studio’s portfolio with distinct visual styles to reach a
            wider audience and stand out within a crowded market. As part of this initiative, we developed a Christmas
            slot in a vibrant pixel-art aesthetic- playful, energetic, and featuring a wonderfully charismatic Santa in
            a deliberately quirky visual world.
            The result resonated strongly with players, becoming one of our most well-received stylistic experiments.
        </div>,
        description: <div className={"text-center text-xl text-gray-400 font-inter"}>
            <ShowreelSection
                videoUrl={"https://storage.googleapis.com/lesia-k/SlotArt2024/Slot10.SantaTime/SantaTime720.mp4"}/>

            <h2 className={"md:text-7xl text-3xl font-boldonse p-5"}>Game Symbols</h2>
            <SlotInfoCardComponent
                rtp={96.5}
                title="Santa time"
                symbols={[
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot10.SantaTime/SeparatedElements/Character.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot10.SantaTime/SeparatedElements/Character2.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot10.SantaTime/SeparatedElements/Present.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot10.SantaTime/SeparatedElements/Symbol2.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot10.SantaTime/SeparatedElements/Symbol3.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot10.SantaTime/SeparatedElements/Symbol4.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot10.SantaTime/SeparatedElements/Symbol5.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot10.SantaTime/SeparatedElements/Trees.png',

                ]}
            /></div>,
        characterImage: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot10.SantaTime/SeparatedElements/Character.png',
        images: [
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot10.SantaTime/SantaTime1.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot10.SantaTime/SantaTime2.gif',
        ]
    },
    {
        id: 'muerto',
        title: 'Muerto',
        icon: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot2.MuertoSlot/MuertoSlotIcon.png',
        descriptionTxt: <div className={"text-white"}>
            A Halloween-themed slot inspired by the Day of the Dead.
            The art direction went through several iterations from a darker, more macabre visual style to a softer
            semi-realistic approach that ultimately resonated most with the team. This balance of festive vibrancy and
            gentle stylization created a distinctive, approachable aesthetic.
            The slot’s main character later became one of the studio’s key marketing mascots, reinforcing brand identity
            across promotional materials.
        </div>,
        description: <div className={"text-center text-xl text-gray-400 font-inter"}>
            <ShowreelSection
                videoUrl={"https://storage.googleapis.com/lesia-k/SlotArt2024/Slot2.MuertoSlot/Muerto720.mp4"}/>

            <h2 className={"md:text-7xl text-3xl font-boldonse p-5"}>Game Symbols</h2>
            <SlotInfoCardComponent
                rtp={96.5}
                title="Muerto"
                symbols={[
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot2.MuertoSlot/SeparatedElements/Background.jpg',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot2.MuertoSlot/SeparatedElements/L1.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot2.MuertoSlot/SeparatedElements/T1.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot2.MuertoSlot/SeparatedElements/Scatter.png',
                    'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot2.MuertoSlot/SeparatedElements/character.png',
                ]}
            /></div>,
        characterImage: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot2.MuertoSlot/SeparatedElements/character.png',
        images: [
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot2.MuertoSlot/Muerto1.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot2.MuertoSlot/Muerto3.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot2.MuertoSlot/Muerto2.gif',
        ]
    },
    {
        id: 'jelly-stars',
        title: 'Jelly Stars',
        icon: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot3.JellyStars/JellyStarsIcon.png',
        descriptionTxt: <div className={"text-white"}>
            A classic candy-themed slot a must-have for any studio’s portfolio.
            What makes this project stand out is its remarkably fast art production cycle. The full visual development
            (art + animation) was completed in just two weeks. Through precise workflow synchronization, the team was
            not only able to deliver the main slot on time but also produce two additional reskins, effectively
            stabilizing the studio’s roadmap.
            It’s hard to believe that the entire art package was created in only two weeks by just two artists and one
            animator - but it beautifully demonstrates the team’s cohesion and production efficiency.
        </div>,
        description: <div className="text-left text-xl text-gray-400 font-inter">
            <ShowreelSection
                videoUrl={"https://storage.googleapis.com/lesia-k/SlotArt2024/Slot3.JellyStars/JellyStars720.mp4"}/>
        </div>,
        characterImage: '',
        images: [
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot3.JellyStars/JellyStars1.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot3.JellyStars/JellyStars2.png',
        ]
    },
    {
        id: 'greek-gods',
        title: 'Greek Gods',
        icon: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot4.GreekGods/GreekGodsIcon.png',
        description: null,
        descriptionTxt: <div className={"text-white"}>
            A slot in the classic theme of Greek gods - the most complex and ambitious title in our portfolio.
            This project presented a significant artistic challenge: selecting the right cast of mythological characters
            and establishing a cohesive visual rhythm within a screen densely populated with elements. To enhance
            narrative depth, the slot features three epic bonus games. Drawing inspiration from Greek mythology, I
            developed a concept based on three of Hercules’ legendary labors, each interpreted as its own distinct bonus
            experience.
            The result is a richly layered slot that blends classical mythology with contemporary visual storytelling.
        </div>,
        characterImage: '',
        images: [
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot4.GreekGods/Athena%20Tactics.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot4.GreekGods/GreekGods2.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot4.GreekGods/GreekGods3.gif',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot4.GreekGods/GreekGod4.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot4.GreekGods/ariadna_scene_lanscape.png',
        ]
    },
    {
        id: 'joker',
        title: 'Joker',
        icon: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot5.Joker/JokerIcon.png',
        description: null,
        characterImage: '',
        descriptionTxt: <div className={"text-white"}>
            A Joker-themed slot, embracing one of the essential archetypes of classic slot design.
            For this title, the art direction draws inspiration from vintage circus aesthetics and grand theatrical
            shows. The Joker is inherently a complex character, and my goal was to reinterpret him as a unique,
            memorable figure - slightly enigmatic yet supported by bold, expressive visuals.
            The result is a character-driven slot with a strong narrative presence and a striking graphic identity.
        </div>,
        images: [
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot5.Joker/Background%2BReel.jpg',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot5.Joker/Joker1.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot5.Joker/Joker2.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot5.Joker/Joker3.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot5.Joker/Joker4.gif',
        ]
    },
    {
        id: 'cosmic',
        title: 'Cosmic',
        icon: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot6.CosmicSlot/CosmicSlotIcon.png',
        description: <ShowreelSection
            videoUrl={"https://storage.googleapis.com/lesia-k/SlotArt2024/Slot6.CosmicSlot/CosmicSlot720.mp4"}/>,
        characterImage: '',
        images: [
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot6.CosmicSlot/CosmicSlot1.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot6.CosmicSlot/CosmicSlot2.png',
        ]
    },
    {
        id: 'buffalo',
        title: 'Buffalo',
        icon: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot7.Buffalo/BuffaloIcon.png',
        description: null,
        descriptionTxt: <div className={"text-white"}>
            A Buffalo-themed slot, reimagining one of iGaming’s most iconic genres.
            Together with the team, we revisited the classic Buffalo concept and transformed it through the lens of
            vintage cartoon aesthetics - a style deeply cherished within our art team. The result is a playful yet
            character-driven reinterpretation that brings fresh personality to a well-established theme.
            This project also became my personal favorite among our unreleased title
        </div>,
        characterImage: '',
        images: [
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot7.Buffalo/Buffalo1.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot7.Buffalo/Buffalo2.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot7.Buffalo/Buffalo3.png',
        ]
    },
    {
        id: 'dragon',
        title: 'Dragon',
        icon: 'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot8.Dragon/GragonIcon.png',
        description: null,
        characterImage: 'https://storage.googleapis.com/lesia-k/SlotArt2024/DragonCatana.png',
        images: [
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot8.Dragon/DragonSlot1.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot8.Dragon/DragonSlot2.png',
            'https://storage.googleapis.com/lesia-k/SlotArt2024/Slot8.Dragon/DragonSlot3.png',
        ]
    },
];
